/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Master Data Service — base mappings
 * Fetch master-data mappings by resource type. Base URL matches `https://mdsstaging.devinfinitylearn.in/stage` from staging curls. Host apps should route requests via the `masterData` API client.
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  GetAllMappingsParams,
  GetAllMappingsResponse,
  HTTPValidationError,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns id/name mappings for the given resource type. Request body is empty; pass `resource_type` as a query parameter.
 * @summary Get All Mappings
 */
export const getAllMappings = (
  params: GetAllMappingsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetAllMappingsResponse>(
    { url: `/base/get-all-mappings`, method: "POST", params, signal },
    options,
  );
};

export const getGetAllMappingsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAllMappings>>,
    TError,
    { params: GetAllMappingsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAllMappings>>,
  TError,
  { params: GetAllMappingsParams },
  TContext
> => {
  const mutationKey = ["getAllMappings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAllMappings>>,
    { params: GetAllMappingsParams }
  > = (props) => {
    const { params } = props ?? {};

    return getAllMappings(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAllMappingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAllMappings>>
>;

export type GetAllMappingsMutationError = HTTPValidationError;

/**
 * @summary Get All Mappings
 */
export const useGetAllMappings = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAllMappings>>,
      TError,
      { params: GetAllMappingsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getAllMappings>>,
  TError,
  { params: GetAllMappingsParams },
  TContext
> => {
  const mutationOptions = getGetAllMappingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
